export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const prefix = `${name}=`;
  const row = document.cookie.split('; ').find(entry => entry.startsWith(prefix));

  if (row === undefined) {
    return undefined;
  }

  return row.slice(prefix.length);
}

export function setCookie(name: string, value: string, attributes = ''): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie = `${name}=${value}; Path=/;${attributes}`;
}

export function deleteCookie(name: string): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax`;
}
